/* eslint-disable react/no-danger -- Rich text is sanitized with DOMPurify before rendering. */
import React, { useState } from 'react';
import { connect, history } from 'umi';

import classnames from 'classnames';
import { Modal as WebModal } from 'antd';
import DOMPurify from 'dompurify';
import useGCPI18n from '@/hooks/useGCPI18n';
import { sanitizeParam } from '@/utils/sanitize';
// import { onHistoryPush, goBack, formatDate } from '@/utils/utils';
// import checkFilled from '@/assets/images/circled-check-filled.svg';
import rewardSuccessTip from '@/assets/images/memership/reward-success-tip.svg';
import MemberHeader from '../MemberHeader';
// import RewardDetailMedalWeb from '../RewardDetailMedalWeb';
import {
  createMemberRewardsDispatchProps,
  memberRewardsStateToProps,
  MemberRewardDialogs,
  MemberRewardsContent,
  RewardStateTabs,
  RewardStatus,
  RewardSummary,
  useMemberRewardActions,
} from '../MemberMyRewards/shared';
import styles from './index.less';

const MemberMyRewards = props => {
  const { saveMemData, qryUserRewardListDXP, claminMemRewardDXP, myMemRewardsList } = props;
  const GCPI18n = useGCPI18n();

  const membershipTypeCode = sanitizeParam(history.location.query?.membershipTypeCode);
  // const { membershipTypeCode, deviceType } = history.location.query
  // console.log('deviceType', deviceType);

  // 空字符串代表all，A代表待领取UnClaimed，B代表已领取Claimed
  const [showClaimedModal, setShowClaimedModal] = useState(false);
  const [rewardItem, setRewardItem] = useState(null);
  const [showRewardModal, setShowRewardModal] = useState(false);

  const rewardActions = useMemberRewardActions({
    qryUserRewardListDXP,
    saveMemData,
    claminMemRewardDXP,
    membershipTypeCode,
    GCPI18n,
    onBeforeClaim: () => setShowRewardModal(false),
    onClaimSuccess: () => setShowClaimedModal(true),
  });

  const handleGoDetail = item => {
    // 跳转到奖励详情页面
    // const { keyId } = item;
    // onHistoryPush('/memberShipCenterRewardDetail', {
    //   keyId,
    // });
    setRewardItem(item);
    setTimeout(() => {
      setShowRewardModal(true);
    }, 100);
  };

  // const renderClaimedModal = () => (
  //   <Modal
  //     wrapClassName={`transparentModalWrap ${styles.claimedModal}`}
  //     visible={showClaimedModal}
  //     transparent
  //     maskClosable={false}
  //   >
  //     <div className={styles.claimedContain}>
  //       <div className={styles.tipImg}>
  //         <img src={checkFilled} alt="" />
  //       </div>
  //       <div className={styles.congratulationMessage}>{GCPI18n({ id: 'lb_mian_claimed_success' })}</div>
  //       <div className={styles.luckyMessage}>{GCPI18n({ id: 'lb_mian_claimed_success_message' })}</div>
  //       <div className={styles.okButton} onClick={() => setShowClaimedModal(false)}>
  //         {GCPI18n({ id: 'lb_reduce_success_btn' })}
  //       </div>
  //     </div>
  //   </Modal>
  // );

  const renderRewardModal = () => (
    <WebModal
      visible={showRewardModal}
      title=""
      width={500}
      // onOk={() => setShowRewardModal(false)}
      className={styles.modal}
      onCancel={() => setShowRewardModal(false)}
      footer={null}
    >
      <div>
        <RewardSummary
          styles={styles}
          item={rewardItem}
          GCPI18n={GCPI18n}
          onClick={handleGoDetail}
          className={styles.rewardPopContain}
          right={null}
        />
        {rewardItem?.comments && (
          <div className={styles.rewardPopDetail}>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(rewardItem?.comments || ''),
              }}
            />
          </div>
        )}
        <div className={styles.rewardPopBottom}>
          <div className={styles.rightBottom}>
            <RewardStatus
              styles={styles}
              item={rewardItem}
              GCPI18n={GCPI18n}
              onClaim={rewardActions.handleClickClaimButton}
            />
          </div>
        </div>
      </div>
    </WebModal>
  );

  return (
    <div className={styles.page}>
      <MemberHeader
        title="My Reward"
        goBack={() => {
          history.goBack();
        }}
      />
      <RewardStateTabs
        styles={styles}
        classnames={classnames}
        state={rewardActions.state}
        GCPI18n={GCPI18n}
        onChange={rewardActions.handleChangeState}
      />
      <MemberRewardsContent
        styles={styles}
        rewards={myMemRewardsList}
        GCPI18n={GCPI18n}
        onGoDetail={handleGoDetail}
        onClaim={rewardActions.handleClickClaimButton}
        showClaimedModal={showClaimedModal}
        claimedImage={rewardSuccessTip}
        onCloseClaimed={() => setShowClaimedModal(false)}
        claimedBodyClassName={`.transparentModalWrap ${styles.claimedModal}`}
        extra={(
          <>
            {showRewardModal && renderRewardModal()}
            <MemberRewardDialogs {...rewardActions} />
          </>
        )}
      />
    </div>
  );
};

export default connect(
  memberRewardsStateToProps,
  createMemberRewardsDispatchProps,
)(MemberMyRewards);
